// Dynamic theme configuration based on special occasions

const specialThemes = {
  diwali: {
    name: 'Diwali',
    primary: '#FF6B35',
    secondary: '#FFD23F',
    accent: '#EE4266',
    text: '#2A1810',
    dates: [
      { month: 10, day: 24 },
      { month: 10, day: 25 },
      { month: 10, day: 26 },
      { month: 10, day: 27 },
      { month: 10, day: 28 },
      { month: 11, day: 1 },
      { month: 11, day: 12 },
      { month: 11, day: 13 }
    ]
  },
  christmas: {
    name: 'Christmas',
    primary: '#165B33',
    secondary: '#BB2528',
    accent: '#F8B229',
    text: '#0F3D1E',
    dates: [
      { month: 11, day: 20 },
      { month: 11, day: 21 },
      { month: 11, day: 22 },
      { month: 11, day: 23 },
      { month: 11, day: 24 },
      { month: 11, day: 25 },
      { month: 11, day: 26 },
      { month: 0, day: 1 }
    ]
  },
  independence: {
    name: 'Independence Day',
    primary: '#FF9933',
    secondary: '#138808',
    accent: '#000080',
    text: '#1A1A1A',
    dates: [
      { month: 7, day: 13 },
      { month: 7, day: 14 },
      { month: 7, day: 15 },
      { month: 7, day: 16 }
    ]
  },
  republic: {
    name: 'Republic Day',
    primary: '#FF9933',
    secondary: '#138808',
    accent: '#000080',
    text: '#1A1A1A',
    dates: [
      { month: 0, day: 24 },
      { month: 0, day: 25 },
      { month: 0, day: 26 },
      { month: 0, day: 27 }
    ]
  },
  holi: {
    name: 'Holi',
    primary: '#E63946',
    secondary: '#F4A261',
    accent: '#2A9D8F',
    text: '#1A1A1A',
    dates: [
      { month: 2, day: 13 },
      { month: 2, day: 14 },
      { month: 2, day: 15 },
      { month: 2, day: 16 }
    ]
  }
};

const defaultTheme = {
  name: 'Default',
  primary: '#8B5E34',
  secondary: '#B6916F',
  accent: '#E3BE82',
  text: '#2F211A',
  background: '#FBF4EA',
  surface: '#FFFFFF',
  border: '#E4D2BA'
};

export const getCurrentTheme = () => {
  const now = new Date();
  const month = now.getMonth();
  const day = now.getDate();

  for (const [key, theme] of Object.entries(specialThemes)) {
    const isSpecialDay = theme.dates.some(
      date => date.month === month && date.day === day
    );
    if (isSpecialDay) {
      return { ...theme, isSpecial: true };
    }
  }

  return { ...defaultTheme, isSpecial: false };
};

export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.style.setProperty('--primary', theme.primary);
  root.style.setProperty('--secondary', theme.secondary);
  root.style.setProperty('--accent', theme.accent);
  root.style.setProperty('--text-primary', theme.text);
  if (theme.background) root.style.setProperty('--background', theme.background);
  if (theme.surface) root.style.setProperty('--surface', theme.surface);
  if (theme.border) root.style.setProperty('--border', theme.border);
};
